<div class="map-style" [ngClass]="{'drawing-mode':isDrawingMode}" #map>
    <div class="drawing-mode-title" *ngIf="isDrawingMode" @fadeSlideIn>
        <div class="title-tag">Drawing Mode | <a class="text-danger" href="javascript:void(0)"
                (click)="cancelDrawingMode($event)">Cancel</a></div>
    </div>
</div>